import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { Component, OnDestroy } from "@angular/core";
import { BrandCampaign } from "../../../shared/models/brandCampaign";
import { NotificationService } from "../../../shared/services/notification.service";
import { BrandCampaignService } from "../shared/services/brand-campaign.service";

@Component({
  selector: "app-brand-campaign-pos",
  templateUrl: "./brand-campaign-pos.component.html",
  styleUrls: ["./brand-campaign-pos.component.scss"],
})
export class BrandCampaignPosComponent implements OnDestroy {
  public campaign: BrandCampaign;
  public saving = false;
  public savingError = false;
  public loading = false;
  private subscriptions = new Subscription();

  constructor(
    protected readonly dialog: MatDialog,
    protected readonly brandCampaignService: BrandCampaignService,
    protected readonly notificationService: NotificationService,
  ) {
    this.campaign = this.brandCampaignService.currentBrandCampaign;
  }

  public ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  public onSave(): void {
    this.saving = true;
    this.subscriptions.add(
      this.brandCampaignService.updateBrandCampaign(this.campaign).subscribe(
        (campaign) => {
          this.campaign = campaign as BrandCampaign;
          this.saving = false;
          this.savingError = false;
        },
        () => {
          this.notificationService.error("Campaign could not be updated");
          this.saving = false;
          this.savingError = true;
        },
      ),
    );
  }
}
